<h2 class="text-center" mat-dialog-title>Voertuig {{ data.user?.name }}</h2>
<mat-dialog-content>
    <mat-form-field class="w-100" appearance="fill">
        <mat-label>Kenteken voertuig</mat-label>
        <input [formControl]="form.controls.vehicle" matInput placeholder="AA-AA-AA" type="text" />
        <mat-error [control]="form.controls.vehicle"></mat-error>
    </mat-form-field>
    <mat-checkbox [formControl]="form.controls.common">Standaard</mat-checkbox>
    @if (!form.value.common) {
        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Voor datum</mat-label>
            <input
                [matDatepicker]="pickerStart"
                [formControl]="form.controls.date"
                (focus)="pickerStart.open()"
                matInput
                placeholder="Voor datum" />
            <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
            <mat-error [control]="form.controls.date"></mat-error>
        </mat-form-field>
    }
</mat-dialog-content>
<mat-dialog-actions class="justify-content-between">
    <button mat-button mat-dialog-close>Sluiten</button>
    <button [disabled]="saving" (click)="save()" mat-raised-button color="primary">
        Opslaan
        @if (saving) {
            <i class="fas fa-circle-notch fa-spin"></i>
        }
    </button>
</mat-dialog-actions>
